import React from 'react';

// a box with two lines of text and a height arrow beside it: a text box whose
// height is set. Drawn like the Stack icon.
function TextBox({ size }) {
  return (
    <svg
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3" y="4" width="12" height="16" rx="1" />
      <path d="M6.5 9h5M6.5 13h5" />
      <path d="M19.5 5v14M17.5 7l2-2 2 2M17.5 17l2 2 2-2" />
    </svg>
  );
}

export default TextBox;
